import React from "react"

import { twMerge } from "#lib/twMergeConfig"

/**
 * @param text
 * @param shortText optional short version of the text, disables line-clamp and uses short text version, which is then switched to long text
 * @param visible is the text fully visible
 * @param className additional classes
 * @param lineClampClasses tailwind line-clamp classes to change lines visible per screen size, default 3 lines - usage "line-clamp-2 xl:line-clamp-5"
 */
export function ExpandableText({
  text,
  shortText,
  visible,
  className,
  lineClampClasses,
}: {
  text: string
  shortText?: string
  visible: boolean
  className?: string
  lineClampClasses?: string
}) {
  return (
    <div>
      <p
        className={twMerge(
          !visible ? `text-gray-50 opacity-100` : "line-clamp-none text-gray-50",
          className,
          !visible && !shortText && "line-clamp-3",
          !visible && !shortText && lineClampClasses,
          "overflow-hidden transition-all duration-500",
        )}>
        {!visible && shortText ? shortText : text}
      </p>
    </div>
  )
}
